import React from "react";
import "./styles.scss";
import TeamLogo from "../../../_partials/TeamLogo";
import Zone from "./Zone";

const HotZoneGraph = ({ data }) => {
  const { homeTeam, awayTeam, competitionId, shots, teamSide } = data;

  return (
    <div className="hotzone-graph-container">
      {teamSide === "home" && (
        <TeamLogo
          team={homeTeam}
          className="left-logo"
          competitionId={competitionId}
        />
      )}
      {teamSide === "away" && (
        <TeamLogo
          team={awayTeam}
          className="right-logo"
          competitionId={competitionId}
        />
      )}

      <Zone className="end-zone first first-end-zone" shots={shots[0]} />

      <Zone shots={shots[1]} />
      <Zone shots={shots[2]} />

      <Zone className="center-zone" shots={shots[3]} />

      <Zone shots={shots[4]} />
      <Zone shots={shots[5]} />

      <Zone className="end-zone last last-end-zone"  shots={shots[6]} />
    </div>
  );
};

export default HotZoneGraph;
